import type { SetSensorEnabledPayload } from '@jums-dashboard/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { sensorsQueryKey } from './useSensors';

export default function useSetSensorEnabled() {
  const qc = useQueryClient();
  return useMutation<{ ok: true }, Error, SetSensorEnabledPayload>({
    mutationFn: (payload) => callFunction<SetSensorEnabledPayload, { ok: true }>('setSensorEnabledCallable', payload),
    onSuccess: (_data, vars) => {
      toast.success(vars.enabled ? 'Sensor enabled.' : 'Sensor disabled.');
      void qc.invalidateQueries({ queryKey: sensorsQueryKey(vars.homeId) });
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to update sensor.');
    },
  });
}
